import React from 'react';
import { TYPE_ICONS, fmtC, fmtCA, fmtDateTime } from './helpers';
import styles from './PaymentInvoice.module.css';

const OrderRow = ({ order, index, showKravein, onView }) => (
  <tr className={styles.clickableRow} onClick={() => onView(order)}>
    <td className={styles.idxCell}>{index + 1}</td>
    <td>
      <div className={styles.ordId}>{order.orderReference}</div>
      {/* <div className={styles.ordPlace}>{order.placeName}</div> */}
    </td>
    <td className={styles.dateCell}>{fmtDateTime(order.orderDate)}</td>
    <td>
      <span className={`tag ${styles.tag} ${styles.tGy}`}>
        {TYPE_ICONS[order.serviceType] || ''} {order.serviceType}
      </span>
    </td>
    <td className={styles.num}>${(order.orderSubtotal ?? 0).toFixed(2)}</td>
    <td className={(order.promo ?? 0) < 0 ? styles.neg : styles.num}>
      {(order.promo ?? 0) < 0 ? fmtC(order.promo) : '—'}
    </td>
    <td className={styles.num}>
      {(order.adjustmentAmount ?? 0) !== 0 ? fmtC(order.adjustmentAmount) : '—'}
    </td>
    <td
      className={`${styles.num} ${
        (order.venueCharges ?? 0) > 0 ? '' : styles.numDim
      }`}
    >
      {(order.venueCharges ?? 0) > 0 ? fmtCA(order.venueCharges) : '—'}
    </td>
    <td className={`${styles.num} ${styles.numBold}`}>
      ${(order.saleValue ?? 0).toFixed(2)}
    </td>
    <td className={styles.num}>-${(order.kraveinFees ?? 0).toFixed(2)}</td>
    <td className={styles.num}>${(order.netPayout ?? 0).toFixed(2)}</td>
    {showKravein && (
      <>
        <td className={`${styles.kraveinCol} ${styles.numOr}`}>
          {(order.kraveinCharges ?? 0) !== 0 ? fmtC(order.kraveinCharges) : '—'}
        </td>
        <td className={`${styles.kraveinCol} ${styles.num} ${styles.numOr}`}>
          {(order.deliveryFee ?? 0) > 0 ? fmtCA(order.deliveryFee) : '—'}
        </td>
        <td className={`${styles.kraveinCol} ${styles.num} ${styles.numOr}`}>
          {fmtCA(order.creditCardFees ?? 0)}
        </td>
        <td className={`${styles.kraveinCol} ${styles.num}`}>
          {fmtC((order.applicationFee ?? 0) - (order.creditCardFees ?? 0))}
        </td>
      </>
    )}
    <td onClick={e => e.stopPropagation()}>
      <button
        className={`button ${styles.btn} ${styles.btnSecondary} ${styles.btnSm}`}
        onClick={() => onView(order)}
      >
        View
      </button>
    </td>
  </tr>
);

export default OrderRow;
